import React from 'react';

// UI Components
import { GIButton } from 'app-components';

// Styles
import { StyledPlanSummaryActionsContainer } from './plansummary.styled';

// Hooks
import { useModal } from '../../../hooks';

// Utilities
import { goToDashboard, isCoverageValid } from './planSummary.utils';

// Common Components
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { ICheckForPendingAppRequest } from './planSummary.types';
import usePlanSummary from './hooks/usePlanSummary';
import { ENROLLMENT_ACTIONS } from '../../../modules/custom-grouping/modals/modalTypes';

const isLastValueNull = (validityResults: Array<boolean | null>) => validityResults?.at(-1) === null;

const PlanSummaryActions = ({ healthPlans, dentalPlans }) => {
    const { checkForPendingApplication, checkDisenrollAndCancelButtonVisibility } = usePlanSummary();
    const { openModal } = useModal();

    const { isDisenrollHealthMedicalPlanVisible, isCancellHealthMedicalPlanVisible } =
        checkDisenrollAndCancelButtonVisibility(healthPlans, dentalPlans);

    const onActionButtonClick = (action: ENROLLMENT_ACTIONS) => {
        const request = {} as ICheckForPendingAppRequest;
        request.healthPlan = healthPlans?.at(-1);
        request.dentalPlan = dentalPlans?.at(-1);
        request.openModal = openModal;
        request.action = action;
        checkForPendingApplication(request);
    };

    const renderActionButton = (condition: boolean, id: string, label: string, action: ENROLLMENT_ACTIONS) => (
        <ConditionalRendering isTrue={condition}>
            <GIButton id={id} data-testid={id} labelId={label} onClickHandler={() => onActionButtonClick(action)} />
        </ConditionalRendering>
    );

    return (
        <StyledPlanSummaryActionsContainer>
            <GIButton
                id="go-to-dashboard_btn"
                data-testid="go-to-dashboard_btn"
                labelId="plansummary.goToDashboard"
                onClickHandler={goToDashboard}
            />

            {renderActionButton(
                isDisenrollHealthMedicalPlanVisible,
                'disenroll_all_btn',
                'plansummary.disenrollfromhealthanddental',
                ENROLLMENT_ACTIONS.SUBMIT,
            )}

            {renderActionButton(
                isCancellHealthMedicalPlanVisible,
                'cancel_all_btn',
                'plansummary.cancelfromhealthanddental',
                ENROLLMENT_ACTIONS.CACNEL,
            )}
        </StyledPlanSummaryActionsContainer>
    );
};

export default PlanSummaryActions;
